'use client';

import styled from 'styled-components';
import { Carousel } from '@mantine/carousel';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled(Carousel)`
  width: fit-content;
  height: fit-content;
  margin: 0 auto;

  padding-bottom: 36px; //INFO: Space for Carousel indicators

  @media (max-width: ${breakpoints.laptop}) {
    width: 632px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 316px;
  }

  .mantine-Carousel-indicator {
    width: 12px;
    height: 6px;
    transition: width 250ms ease;
    background-color: ${colors.aqua};

    &[data-active] {
      width: 40px;
    }
  }

  .mantine-Carousel-controls {
    width: 125%;

    position: absolute;
    left: -12.5%;
  }
`;

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 12px;
`;
